var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedStepXs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 36,
    viewBox: "0 0 217 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 17,
    transform: "matrix(1 0 0 -1 0 17)",
    fill: "#DC4C4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 17,
    transform: "matrix(1 0 0 -1 0 36)",
    fill: "#DC4C4C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 36,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 162 36)",
    fill: "url(#paint0_linear_418_4252)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 36,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 149 36)",
    fill: "url(#paint1_linear_418_4252)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 36,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 160 36)",
    fill: "url(#paint2_linear_418_4252)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 36,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 151 36)",
    fill: "url(#paint3_linear_418_4252)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 36,
    width: 17,
    height: 2.00001,
    transform: "rotate(-90 154 36)",
    fill: "url(#paint4_linear_418_4252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_4252",
    x1: 170.5,
    y1: 36,
    x2: 170.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_4252",
    x1: 157.5,
    y1: 36,
    x2: 157.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_418_4252",
    x1: 168.5,
    y1: 36,
    x2: 168.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_418_4252",
    x1: 159.5,
    y1: 36,
    x2: 159.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_418_4252",
    x1: 162.5,
    y1: 36,
    x2: 162.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStepXs);
export default __webpack_public_path__ + "static/media/red-step-xs.bf7d7e331d469fb20768b9bdd297e03f.svg";
export { ForwardRef as ReactComponent };